import { render } from "./CalendarEventRouterView.vue?vue&type=template&id=c7f03838"
import script from "./CalendarEventRouterView.vue?vue&type=script&lang=ts"
export * from "./CalendarEventRouterView.vue?vue&type=script&lang=ts"
script.render = render

export default script